import script from "./CameraFeed.vue?vue&type=script&setup=true&lang=js"
export * from "./CameraFeed.vue?vue&type=script&setup=true&lang=js"

import "./CameraFeed.vue?vue&type=style&index=0&id=468f8e28&lang=css"

const __exports__ = script;

export default __exports__